import PropTypes from "prop-types";

export default {
	debug: PropTypes.bool,
};
